import { roundDps } from './dps.js';
/**
 * Derived stats of a character from its class, level and worn equipment
 * (ADR 0015). Three numbers and nothing else: one playable class leaves no
 * attribute to choose between. Health and defence say how long a fight can
 * last, damage per second how short it is.
 */
/**
 * Per-level growth, as a fraction of the base stat. Kept low so the gear
 * carries most of a level-20 character (ADR 0015, 2026-09-30): naked, about a
 * fifth of the best outfit's health and damage per second.
 */
const DPS_GROWTH = 0.08;
const HEALTH_GROWTH = 0.06;
function grown(base, level, growth) {
    return base + Math.round(base * growth * (level - 1));
}
const NO_BONUS = { health: 0, defence: 0, dps: 0 };
/** Naked stats grown by level, plus what the worn equipment adds on top. */
export function statsFor(definition, level, bonus = NO_BONUS) {
    const safeLevel = Math.max(1, Math.floor(level));
    const { baseStats } = definition;
    return {
        maxHealth: Math.max(1, grown(baseStats.health, safeLevel, HEALTH_GROWTH) + bonus.health),
        dps: Math.max(1, roundDps(grown(baseStats.dps, safeLevel, DPS_GROWTH) + bonus.dps)),
        defence: Math.max(0, bonus.defence),
    };
}
//# sourceMappingURL=stats.js.map